<template>
  <form @submit.prevent="emitSave" id="SchemaDefinitionTableAddEditDialog">
    <h4 class="mb-4">{{ 'ADD' | translate }}</h4>
    <div class="alert alert-danger alert-dismissible mt-5" v-if="error" id="SchemaDefinitionTableAddEditDialog-errorDiv">
      {{ error }}
      <button type="button" class="close" @click="dismissAlertError()" aria-label="Close" id="SchemaDefinitionTableAddEditDialog-closeButton">
        <span aria-hidden="true" id="SchemaDefinitionTableAddEditDialog-closeButton-span">&times;</span>
      </button>
    </div>
    <div class="alert alert-danger alert-dismissible mt-5" v-if="showConfirmDialog" id="SchemaDefinitionTableAddEditDialog-alert">
      Do you want to update existing file ?
      <button type="button" class="btn btn-success" @click="confirm()" aria-label="Close" id="SchemaDefinitionTableAddEditDialog-yesButton">Yes</button>
      <button type="button" class="btn btn-link" @click="cancel()" aria-label="Close" id="SchemaDefinitionTableAddEditDialog-noButton">No</button>
    </div>
    <div class="form-group" id="SchemaDefinitionTableAddEditDialog-formGroup-Naam">
      <label>{{ 'SUIV_NAME' | translate() }} <span class="asterisk">*</span></label>
      <input type="text" class="form-control form-control-sm" v-model="fileName" disabled id="SchemaDefinitionTableAddEditDialog-formGroup-Naam-input">
    </div>
    <div class="form-group" id="SchemaDefinitionTableAddEditDialog-formGroup-Omschrijving">
      <label>{{ 'XSD_DESCRIPTION' | translate() }} <span class="asterisk">*</span></label>
      <div class="custom-file" id="SchemaDefinitionTableAddEditDialog-formGroup-CustomFile">
        <input ref="importFile" type="file" class="custom-file-input" id="import_file" name="import_file"
          @click="resetImportFile" @change="selectFile" required webkitdirectory>
        <label class="custom-file-label" for="import_file">
          {{ (file && file.name) ? file.name : 'UPLOAD_FILE' | translate }}
        </label>
      </div>
    </div>
    <div class="form-group">
      <label>{{ 'SUIV_DESCRIPTION' | translate() }}</label>
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="productDescription"
        id="SchemaDefinitionTableAddEditDialog-formGroup-Description"
      />
    </div>
    <div class="form-group">
      <label>{{ 'SUIV_PRODUCT' | translate() }}</label>
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="productId"
        id="SchemaDefinitionTableAddEditDialog-formGroup-Product"
      />
    </div>
    <div class="form-group">
      <label>{{ 'AL_VIEWCOD' | translate() }}</label>
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="AL_VIEWCOD"
        id="SchemaDefinitionTableAddEditDialog-formGroup-ViewCode"
      />
    </div>
    <div class="form-group">
      <label>{{ '_PPRC' | translate() }}</label>
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="PPRC"
        id="SchemaDefinitionTableAddEditDialog-formGroup-PPRC"
      />
    </div>
    <div class="mt-4 text-right" id="SchemaDefinitionTableAddEditDialog-buttons">
      <button class="btn btn-link" type="button" @click="emitClose" id="SchemaDefinitionTableAddEditDialog-closeButton">{{ 'CLOSE' | translate }}</button>
      <button class="btn btn-primary" type="button" @click="saveOrUpdate" :disabled="!isFormValid" id="SchemaDefinitionTableAddEditDialog-addButton">{{ 'ADD' | translate
        }}</button>
    </div>
    <div class="cm-container">
      <div class="cm-loader" v-if="loaded">
        <custom-spinner></custom-spinner>
      </div>
    </div>
  </form>
</template>

<script>
import RestService from '../../../service/RestService.js';
import CustomSpinner from '../../CustomSpinner.vue';
export default {
  components: { CustomSpinner },
  props: ['edited', 'loaded', 'errorMessage'],
  data() {
    return {
      rest: this.initRestService(),
      file: {},
      error: '',
      fileName: '',
      productDescription: '',
      productId: '',
      AL_VIEWCOD: '00000',
      PPRC: '20',
      showConfirmDialog: false,
      afdFile: {},
      formatFile: {}
    }
  },
  computed: {
    isFormValid() {
      return this.file;
    }
  },
  methods: {
    confirm() {
      this.emitSave();
      this.showConfirmDialog = false;
    },
    cancel() {
      this.showConfirmDialog = false;
      this.emitClose()
    },
    resetImportFile() {
      this.$refs.importFile.value = null;
    },
    saveOrUpdate() {
      if (this.edited) {
        this.showConfirmDialog = true;
      } else {
        this.emitSave()
        this.showConfirmDialog = false;
      }
    },
    initRestService() {
      return new RestService();
    },
    emitSave() {
      const formData = new FormData();
      formData.append('schemaDefinition_file', this.file);
      formData.append('file_name', this.fileName);
      formData.append('productId', this.productId);
      formData.append('productDescription', this.productDescription);
      formData.append('afdCodeFile', this.afdFile);
      formData.append('formatFile', this.formatFile);
      formData.append('AL_VIEWCOD', this.AL_VIEWCOD);
      formData.append('_PPRC', this.PPRC);
      this.$emit(this.edited ? 'update' : 'save', formData);
      this.file = {}
      this.fileName = ''
      this.afdFile = {}
      this.formatFile = {}
      this.error = ''
      this.productDescription = ''
      this.productId = ''
      // this.AL_VIEWCOD = ''
      // this.PPRC = ''
      this.$emit('clearErrorMessage', this.error);
    },
    emitClose() {
      this.file = {};
      this.afdFile = {}
      this.formatFile = {}
      this.fileName = ''
      this.productDescription = ''
      this.productId = ''
      // this.AL_VIEWCOD = ''
      // this.PPRC = ''
      this.showConfirmDialog = false;
      this.error = '';
      this.$emit('close');
    },
    selectFile: function (evt) {
      const selectedFiles = Array.from(evt.target.files).filter(file => {
        // Replace 'yourCriteria' with the condition for the specific file(s) you want
        return file.name.endsWith('.xsd');
      });
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        const fileName = file.name;
        if (fileName.endsWith('afdCodelists.xsd')) {
          this.afdFile = file;
        } else if (fileName.endsWith('afdFormats.xsd')) {
          this.formatFile = file;
        } else {
          this.file = file;
          this.fileName = fileName;
        }
      }
    },
    dismissAlertError: function () {
      this.error = '';
    }
  },
  watch: {
    edited(newVal, oldVal) {
      this.file = { ...newVal };
      this.fileName = newVal.fileName
    },
    errorMessage(val) {
      this.error = val
    }
  }
}
</script>

<style lang="scss" scoped>
.asterisk {
  color: $danger;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/schema-definition/SchemaDefinitionAddEditDialog.vue